import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { Rating } from '../../models/rating/rating.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class RatingService {

  private serviceName = 'api/Rating'
  constructor(private http: Http,
    private readonly router: Router,
    private cookieService: CookieService) { }

  AddRating(Ratingmodel: Rating): void {
    this.http
      .post(`${this.serviceName}`, Ratingmodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/Rating"]);
      });
  }
  updateRating(Ratingmodel: Rating): void {
    //Todo
    this.http
      .put(`${this.serviceName}`, Ratingmodel, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .subscribe(result => {
        this.router.navigate(["/Rating"]);
      });
  }
  //deleteRating(id: string) {
  //  return this.http.delete(`${this.serviceName}/` + id)
  //    .subscribe(result => {
  //    });
  //}
  deleteRating(id: string) {
    return this.http.delete(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getRatings() {
    return this.http.get(`${this.serviceName}`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getCustomerInfo(id: number) {
    return this.http.get(`${this.serviceName}/GetCustomerInfo?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  UpdateActiveAndInactive(id: number) {
    return this.http
      .post(`${this.serviceName}/` + id, null, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getRating(id: string) {
    return this.http.get(`${this.serviceName}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/rating/rating.service.ts